var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCli = function SvgCli(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.96 63H21.929L19 60.097V26.903L21.928 24h44.144L69 26.903V42.99",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m24.64 40.25 4.841-4.572v-1.477l-4.84-4.46M32 40h8M71.93 49.026h-6.052L56.4 58.504v6.052l9.478 9.478h6.052l9.478-9.478v-6.052l-9.478-9.478Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 61.06,
    r: 5,
    stroke: "currentColor",
    strokeWidth: 3
  })));
};
export default SvgCli;